import './MainLogo.css';
import scribeLogo from '../../../../src/images/scribe_logo.svg';
import { NavigateFunction } from 'react-router-dom';

interface Props {
  nav: NavigateFunction;
}

function MainLogo({ nav }: Props): JSX.Element {
  return (
    <div
      className="LogoContainer"
      onClick={() => {
        nav('/');
      }}
    >
      <img src={scribeLogo} alt="Scribe Logo" />
    </div>
  );
}

export default MainLogo;
